import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConformeData } from '../../shared/conforme.data';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-conforme-escritorio',
  templateUrl: './conforme-escritorio.component.html',
  styleUrls: ['./conforme-escritorio.component.scss'],
})
export class ConformeEscritorioComponent implements OnInit {

  @Input() conformesData: ConformeData;
  @Output() giveMeConformes = new EventEmitter();

  ColumnMode = ColumnMode;

  constructor() { }

  ngOnInit() {
  }

  setPage(pageInfo) {
    this.conformesData.page.offset = pageInfo.offset;
    const envio = {
      page: this.conformesData.page,
      total: this.conformesData.page.count
    };
    this.giveMeConformes.emit(envio);
  }

  getHeaderClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };

  }

  getCellClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };
  }



}
